module.exports = __webpack_public_path__ + "static/media/gentech.b6aa84cf.jpeg";